import {course_getCourses_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {renderCourse} from 'views/Workspace/Course/functions/renderCourse'
import OrganizationContainerContext from '../OrganizationContainerContext'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {renderIf} from "../../../Shared";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {GoDotFill} from "react-icons/go";
import {IoCalendar} from "react-icons/io5";
import EmptyHolder from "../../../../components/EmptyHolder";

const OrganizationCourseByGroups = ({
                                        title,
                                        academic_year, academic_field,
                                        filter_actions = {
                                            sortBy: 'sort-by',
                                            keyword: 'keyword'
                                        },
                                    }) => {
    const t = useTranslate()
    const location = useLocation()

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const {organization} = useContext(OrganizationContainerContext)

    const [owner_id, owner_type] = [getId(organization), getType(organization)]

    const filter = 1;

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            academic_year, academic_field,
            filter,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, academic_year, academic_field, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({
                academic_year, academic_field, filter
            })
        },
        filter_params: {
            owner_id,
            owner_type,
            academic_year, academic_field,
            filter
        },
        pagerInfo: {
            PaginationMeta: NullAsDefault,
            renderItem: renderCourse(),
            RenderEntity: React.Fragment,
            apiInfo: course_getCourses_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
            renderWrap: (child, __, count) => count > 0 && (
                <div className="flex flex-col gap-3">
                    {title?.length > 0 && (
                        <HeaderWithIconLine
                            lineColor="border-blue-200"
                            renderTitle={() => (
                                <div className="flex items-center gap-3">
                                    <GoDotFill size={14} className="text-blue-400"/>
                                    <div style={{wordBreak: 'break-all'}}
                                         className="min-w-0 flex-1 font-bold text-blue-700 tracking-wider">
                                        <div className="max-lines-1">
                                            {title}
                                        </div>
                                    </div>
                                </div>
                            )}
                        />
                    )}
                    <div className="ml-0 md:ml-3 flex flex-col gap-4">
                        {child}
                    </div>
                </div>
            )
        },
        withKey: createPagerKey(refresh_deps),
        renderFilter: NullAsDefault,
        renderSortBy: NullAsDefault,
        SortByWidget: NullAsDefault,
        AdvancedFilter: NullAsDefault,
        AdvancedToggle: NullAsDefault,
        query_params: filter_actions,
        renderHeader: NullAsDefault
    })

    return (
        <div className="flex flex-col gap-3">
            {pager_widget}
        </div>
    )
}

const OrganizationCourseList = ({
                                    filter_actions = {
                                        sortBy: 'sort-by',
                                        keyword: 'keyword',
                                    },
                                }) => {
    const t = useTranslate()
    const {organization} = useContext(OrganizationContainerContext)

    const working_year_field = _.get(organization, 'workspace_settings.courses.groups.working_year_field_groups', [])

    if (!!!_.has(organization, 'workspace_settings.courses.groups.working_year_field_groups')) {
        return <EmptyHolder/>
    }

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-1">
                <h2 className="font-bold text-lg text-gray-800 tracking-wide uppercase">
                    {t('course')}
                </h2>
                <div className="text-color-300 tracking-wider">
                    {t('course introduction description')}
                </div>
            </div>
            {_.orderBy(Object.keys(working_year_field), null, 'desc')
                .map((academic_year, index) => {
                    return (
                        <div key={index} className="flex flex-col gap-1">
                            {
                                academic_year > 0 && (
                                    <HeaderWithIconLine
                                        line={false}
                                        renderTitle={() => (
                                            <div className="flex items-center gap-3">
                                                <IoCalendar size={18} className="text-green-300"/>
                                                <span
                                                    className="font-bold text-lg text-green-700 uppercase tracking-wide">
                                                {` - ${t('academic year')} ${academic_year}`}
                                            </span>
                                            </div>
                                        )}
                                    />
                                )}
                            {
                                _.get(organization, 'workspace_settings.courses.groups.working_year_field_groups.' + academic_year)?.length > 0 &&
                                _.get(organization, 'workspace_settings.courses.groups.working_year_field_groups.' + academic_year).map((academic_field, i) => (
                                        <div key={i} className="ml-0 md:ml-3 flex flex-col gap-4">
                                            <OrganizationCourseByGroups
                                                title={renderIf(!!academic_field, academic_field)}
                                                academic_year={academic_year}
                                                academic_field={academic_field}
                                                filter_actions={filter_actions}
                                            />
                                        </div>
                                    )
                                )
                            }
                        </div>
                    )
                })}
            <div className="h-10"/>
        </div>
    )
}

export default OrganizationCourseList
